/**
 * Shared form defaults for stash item forms
 * Used by AddItemModal, AIAssistedFlow, and URLLookupFlow
 */

export const INITIAL_STASH_FORM = {
  name: '',
  category: '',
  brand: '',
  description: '',
  user_notes: '',
  image_url: '',
  thumbnail_url: '',
  colors: [],
  sentiments: [],
  tags: [],
  primary_color: '',
  secondary_color: ''
};

/**
 * Create a fresh copy of the initial form state
 * @returns {Object} - A new copy of INITIAL_STASH_FORM
 */
export const createInitialForm = () => ({ ...INITIAL_STASH_FORM });

export default INITIAL_STASH_FORM;
